import React, {useState, useEffect} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import Fetch from "./utils/Fetch";
import Constants from "./Constants";

import Loader from "./components/Loader";
import Session from './utils/Session';

import Home from './pages/Home';
import Local from './pages/Local';
import Mircea from './pages/Mircea';

import ChartBalance from './pages/ChartBalance';

import Login from './pages/Login';
import Page404 from './pages/Page404';


function App() {
    return (
        <Init>
            <Router>
                <Switch>
                    
                    <PrivateRoute exact path="/">
                        <Home />
                    </PrivateRoute>

                    <PrivateRoute exact path="/local">
                        <Local />
                    </PrivateRoute>

                    <PrivateRoute exact path="/mircea">
                        <Mircea />
                    </PrivateRoute>

                    <PrivateRoute path="/chart-balance">
                        <ChartBalance />
                    </PrivateRoute>

                    <Route path="/login">
                        <Login />
                    </Route>
                    
                    <Route path="*">
                        <Page404 />
                    </Route>

                </Switch>
            </Router>
        </Init>
    );
}

function Init(props){
    
    const [loading, setLoading] = useState(true);

    useEffect(()=>{

        let options = {
            method: 'POST',
        }

        let url = Constants.API_URL+"/api/init.php";
  
        Fetch.request(url, options)
            .then((response) => response.json())
            .then((json) => {            
                if(json.status === "ok"){
                    if(json.logged_in === "0"){
                        Session.logout();
                    }else{
                        Session.login();
                    }
                    setLoading(false);
                }  
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    if(loading){
        return (<Loader />);
    }

    return (props.children);

}

function PrivateRoute({ children, ...rest }) {

    const isLoggedIn = Session.isLoggedIn();
    
    return (
        <Route
            {...rest}
            render={
                ({ location })=>{
                    localStorage.last_private_route = JSON.stringify(location);
                    if(isLoggedIn){
                        return children;
                    }else{
                        return (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: { from: location }
                                }}
                            />
                        )
                    }
                }
            }
        />
    );
}


export default App;
